import React from 'react';
import styles from './MainLayout.module.css';

interface MainLayoutProps {
  children: React.ReactNode;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
    <div className={styles.layout}>
      <main id="main-content" className={styles.main} role="main" tabIndex={-1}>
        {children}
      </main>
    </div>
  );
};
